<mat-form-field appearance="outline" class="currency-input">
    <mat-label>{{ placeholder }}</mat-label>
    <mat-icon matPrefix>local_atm</mat-icon>
    <input matInput [formControl]="control" (input)="onInput($event)" type="text" autocomplete="off" />
    <mat-icon matSuffix class="txt-money">đ</mat-icon>
    <mat-error *ngIf="control.hasError('required')">
        Vui lòng nhập số tiền.
    </mat-error>
</mat-form-field>